/*jshint esversion: 6 */
import {Container} from 'aurelia-dependency-injection';
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { AccountAdminAPI } from '../../services/admin/accountAdminAPI';
import $ from 'jquery';
import Quill from 'quill';
@inject(AuthService, Router, AccountAdminAPI, UserMessageService)
export class User {
  constructor(authService, router, api, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.api = api;
    this.userMessageService = userMessageService;
    this.showAffiliateSection = false;
    this.showAffiliateLinkCode = true;
    this.saving = false;
    this.whitelabel_id = null;
  }
attached() {

        var Block = Quill.import('blots/block');
        Block.tagName = 'DIV';
        Quill.register(Block, true);
        this.branded_video_editor = new Quill('#branded_video', {
            modules: {
                toolbar: [
                  [{'size': [] }, {'color': []}],  // custom dropdown
                    //['bold', 'italic', 'underline', 'code'],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image', 'link']
                ]
              },
              bounds: '#scrolling-container',

              theme: 'snow'  // or 'bubble'
          });

        var Block1 = Quill.import('blots/block');
        Block1.tagName = 'DIV';
        Quill.register(Block1, true);
          this.simple_collection_editor = new Quill('#simple_collection', {
            modules: {
                toolbar: [
                  [{'size': [] }, {'color': []}],  // custom dropdown
                    //['bold', 'italic', 'underline', 'code'],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image', 'link']
                ]
              },
              bounds: '#scrolling-container',

              theme: 'snow'  // or 'bubble'
          });
      }
  activate(params) {
    this.loading = true;
    this.showLogoUpload = false;
    this.defaultBusinessType = 'Select...';
    if(params.id)
      this.id = params.id;
    else
      this.id = null;


    if(params.whitelabel_id) {
      this.whitelabel_id = params.whitelabel_id;
    } else {
      this.whitelabel_id = null;
    }
    this.is_vendasta_user = false;
    if(localStorage.getItem('tp_nav_url') && $('#product-navigation-bar-container').length > 0){
        this.is_vendasta_user = true;
    }


    this.api.getAccountStatusList(this.authService.getUser().token, this.accountStatusListSuccess.bind(this), this.saveLoadError.bind(this));



  }

  accountStatusListSuccess(list) {
    this.accountStatusList = list;
    this.api.getBusinessTypeList(this.businessTypeSuccess.bind(this), this.saveLoadError.bind(this));
  }

  businessTypeSuccess(list) {
    this.businessTypeList = list;

    if (this.id !== null) {
      this.load();
    } else {
      this.reset();
    }
  }

  load() {
    this.api.getUserData(
      this.id,
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this));
  }

  reset() {
    this.email = null;
    this.role = 'YTMANAGER';
    this.prevRole = 'YTMANAGER';
    this.firstName = null;
    this.lastName = null;
    this.password = null;
    this.active = true;
    this.managed = false;
    this.manager_user_id = null;
    this.orgName = null;
    this.website = null;
    this.orgEmail = null;
    this.orgPhone = null;
    this.accountStatus = '2';
    this.logo_file = null;
    this.showLogoUpload = true;
    this.request_count = 0;
    this.new_request_count = this.request_count;
    this.loading = false;

  }

  save() {
    if (this.validate()) {
      this.saving = true;
      this.api.adminSave(
        this.getUserData(),
        this.getAccountData(),
        (this.logo_files && this.logo_files.length > 0 && this.showLogoUpload ? this.logo_files[0] : null),
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this));
    }
  }

  deleteAssets() {
    if (confirm("Are you sure you want to delete this user's assets?")) {
      this.saving = true;
      this.api.deleteAssets(
        this.id,
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this));
    }
  }

  saveLoadSuccess(data) {
    this.loading = false;
    this.setData(data);

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'Saved!');
    }
    this.saving = false;
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
    this.loading = false;
    this.saving = false;
  }

  setData(data) {
      console.log('DATA>>>>');
      console.log(data);
    this.id = data.user.id;
    this.email = data.user.email;
    this.role = data.user.role;
    this.prevRole = data.user.role;
    this.firstName = data.user.first_name;
    this.lastName = data.user.last_name;
    this.password = null;
    this.active = data.user.active;
    this.managed = data.user.managed;
    this.manager_user_id = data.user.manager_user_id;
    this.orgName = data.account.org_name;
    this.website = data.account.website;
    this.orgEmail = data.account.org_email;
    this.orgPhone = data.account.org_phone;
    this.accountStatus = data.account.status.toString();
    this.customer_id = data.account.customer_id;
    this.logo_file = data.account.logo_file;
    this.userLogoPath = data.account.logo_file !== null ? this.userLogoPath = 'api/admin/account/getLogoFile/' + this.id + '?Authorization=' + this.authService.getUser().token + '&t=' + new Date() : null;
    this.showLogoUpload = this.userLogoPath === null;
    this.defaultBusinessType = data.account.business_type;
    this.businessTypeDetail = data.account.business_type_detail;
    this.mlinkReturnUrl = data.account.mlink_return_url;
    this.request_count = parseInt(data.account.request_count);
    this.subscription_type = data.account.subscription_type;

    if (isNaN(this.request_count)) {
      this.request_count = 0;
    }
    this.new_request_count = this.request_count;

    // Affiliate program fields (preserved here for round-tripping)
    let isAffiliate = data.account.joined_affiliate_program !== null;
    this.address_1 = data.account.address_1;
    this.address_2 = data.account.address_2;
    this.city = data.account.city;
    this.joined_affiliate_program = data.account.joined_affiliate_program;
    this.referred_by = data.account.referred_by;
    this.state = data.account.state;
    this.zipcode = data.account.zipcode;
    this.ein = data.account.ein;
    this.showAffiliateSection = isAffiliate;
    this.recurring_enabled = data.account.monthly_recurring_credits != null;
    this.recurring_count = parseInt(data.account.monthly_recurring_credits);
    this.recurring_limit = data.account.monthly_recurring_credits_limit_rollover;
    this.captureKey = data.account.link_id;
    this.branded_video_editor.container.firstChild.innerHTML = data.verbiage.branded_video_verbiage;
    this.simple_collection_editor.container.firstChild.innerHTML = data.verbiage.simple_collection_verbiage;

    this.is_trial_expired=data.is_trial_expired;
    this.is_trial_extended=data.is_trial_extended;
    this.trial_days_left=data.trial_days_left;
    if (isNaN(this.recurring_count)) {
      this.recurring_count = 0;
    }

    this.new_recurring_count = this.recurring_count;
    this.whitelabel_id = data.user.whitelabel_id;

    this.customOpenerPath = data.account.has_custom_opener ? '/api/admin/account/getCustomOpener/' + this.id + '?Authorization=' + this.authService.getUser().token + '&t=' + new Date() : null;
    if(this.whitelabel_id)
      this.api.getWLManagers(this.whitelabel_id, this.authService.getUser().token,
      (users) => {
        this.wlmanagers = users;
        this.wlmanagersReassign = users.filter((item) => item.id != this.id);

      },
      this.saveLoadError.bind(this));
  }

  getUserData() {
    var data = {
      'id': this.id,
      'email': this.email,
      'password': this.password,
      'role': this.role,
      'first_name': this.firstName,
      'last_name': this.lastName,
      'active': this.active,
      'managed': this.managed,
      'whitelabel_id': this.whitelabel_id,
      'manager_user_id': this.manager_user_id,
      'reassign_manager_user_id': this.reassign_manager_user_id,
      'branded_video_verbiage': this.branded_video_editor.container.firstChild.innerHTML,
      'simple_collection_verbiage': this.simple_collection_editor.container.firstChild.innerHTML
    };

    return data;
  }

  getAccountData() {
    var data = {
      'owner_user_id': this.id,
      'org_name': this.orgName,
      'org_email': this.orgEmail,
      'org_phone': this.orgPhone,
      'first_name': this.firstName,
      'last_name': this.lastName,
      'website': this.website,
      'business_type': this.businessType === null ? this.defaultBusinessType : this.businessType.display_value,
      'business_type_detail': (this.businessType !== null && this.businessType.use_detail) || this.businessType === null ? this.businessTypeDetail : null,
      'request_count': this.request_count,
      'logo_file': this.logo_file,
      'mlink_return_url': this.mlinkReturnUrl,
      'status': this.accountStatus,
      'subscription_type': this.subscription_type,
      // Affiliate program fields
      'address_1': this.address_1,
      'address_2': this.address_2,
      'city': this.city,
      'joined_affiliate_program': this.joined_affiliate_program,
      'referred_by': this.referred_by,
      'state': this.state,
      'zipcode': this.zipcode,
      'ein': this.ein,
      'monthly_recurring_credits': this.recurring_enabled ? this.recurring_count : null,
      'monthly_recurring_credits_limit_rollover': this.recurring_enabled ? this.recurring_limit : null
    };

    return data;
  }

  findBusinessType(display_value) {
    for (var i = 0; i < this.businessTypeList.length; i++) {
      if (this.businessTypeList[i].display_value === display_value) {
        return this.businessTypeList[i];
      }
    }

    return;
  }

  businessTypeComparer(bt1, bt2) {
    if (bt1 && bt2) {
      return bt1.display_value === bt2.display_value;
    }

    return false;
  }

  extendUserPlus14DayTrial(){

    this.api.extendUserPlus14DayTrial(this.id, this.authService.getUser().token,
    (data) => {

      this.load();
      this.userMessageService.setUserMessage('user', 'Trial extended');
    },
   () =>{
    this.userMessageService.setUserError('user', 'Trial not extended');
   }
    )
  }

  validate() {
    var pass = true;

    if (this.email === null || this.email.trim() === '') {
      this.userMessageService.setUserError('user', 'Email is empty');
      pass = false;
    }

    if (!this.is_email(this.email)) {
      this.userMessageService.setUserError('user', 'Email is not a valid email address');
      pass = false;
    }

    if (this.firstName === null || this.firstName.trim() === '') {
      this.userMessageService.setUserError('user', 'First name is empty');
      pass = false;
    }

    if (this.lastName === null || this.lastName.trim() === '') {
      this.userMessageService.setUserError('user', 'Last name is empty');
      pass = false;
    }

    return pass;
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailReg.test(email);
  }

  creditsChanged() {
    var value = parseInt(this.new_request_count, 10);

    if (isNaN(value)) {
      this.new_request_count = this.request_count;
    } else {
      this.request_count = this.new_request_count;
    }
  }


  showVideoClicked(url) {
    this.showVideo = true;
    this.videoPlayer.src = url;
    this.videoPlayer.load();
    this.videoPlayer.play();
  }

  showVideoClosed() {
      this.showVideo = false;
      if (this.videoPlayer) {
          this.videoPlayer.pause();
      }
  }

  saveCustomOpener() {

    if (this.customOpener_files && this.customOpener_files.length > 0) {
      this.saving = true;

      this.api.saveCustomOpener(
        this.id,
        this.customOpener_files[0],
        this.authService.getUser().token,
        () => {
          this.saving = false;
          this.showCustomOpenerUpload = false;
          this.customOpenerPath = '/api/admin/account/getCustomOpener/' + this.id + '?Authorization=' + this.authService.getUser().token + '&t=' + new Date();
          this.userMessageService.setUserMessage('user', 'Saved!');
        },
        (msg) => {
          this.saving = false;

          this.userMessageService.setUserError('user', msg);
        });
    }

  }

  recurringCreditsChanged() {
    var value = parseInt(this.new_recurring_count, 10);

    if (isNaN(value)) {
      this.new_recurring_count = this.recurring_count;
    } else {
      if(this.new_recurring_count < 0)
        this.new_recurring_count = 0;
      this.recurring_count = this.new_recurring_count;
    }
  }

  copyBrandLink() {
    this.copyTextToClipboard(window.site_url+ "/#/capture/brand/" + this.captureKey);
    this.userMessageService.setUserMessage('user', 'Copied!');
  }
  copyBrandLink1() {
    this.copyTextToClipboard(window.site_url + "/#/capture/brand/" + this.captureKey +"?method=fileupload&uploadonly=1");
    this.userMessageService.setUserMessage('user', 'Copied!');
  }

  copyCaptureLink()
  {
    this.copyTextToClipboard(window.site_url+ "/#/capture/link/" + this.captureKey);
    this.userMessageService.setUserMessage('user', 'Copied!');
  }

  copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }
}
